import PropTypes from "prop-types";

export const AccentLavenderIndigo = ({ children }) => {
  return <span className="accent-lavender-indigo">{children}</span>;
};

AccentLavenderIndigo.propTypes = {
  children: PropTypes.node,
};
